module.exports = __webpack_public_path__ + "img/default-avatar.8cf64c59.svg";